// extracted by mini-css-extract-plugin
export default {"footer":"DektopFooter_footer__3sA2_"};